<template>
  <div id="app">
    <div>
	  <router-view :key='$route.fullPath'></router-view>
    </div>
  </div>
</template>

<script>
export default {
	name:'App',
	  methods: {
		
	  }
}
</script>

<style>
#app {
  font-family: PingFang SC-Medium, PingFang SC;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue